// two bobby: order attribution, v2 (10 Oct 2026). Reads what snippets/tb-touch.liquid saved and writes it onto the cart:
//   attributes  _utm_source _utm_medium _utm_campaign _utm_content _utm_term _fbclid _ad_params _landing_page _touch_at
//               _ft_utm_campaign _ft_landing _ft_touch_at _path
//   line property _added_from = "<page type>:<handle>|<section>[-sticky|-quick-add|-addons|-complete-set]" on every add.
// Attributes are written at page load (so a fast Checkout tap after one add cannot beat them), after every
// /cart/add|change|update, and on pageshow. Names are fixed: Claude chat's CAC queries read them from orders.
(() => {
  const read = (key) => {
    try { const v = localStorage.getItem(key); if (v) return JSON.parse(v); } catch (e) {}
    if (key !== 'tb_last_touch') return null;
    try { const m = document.cookie.match(/(?:^|; )tb_lt=([^;]*)/); return m ? JSON.parse(decodeURIComponent(m[1])) : null; } catch (e) { return null; }
  };
  const clip = (v, n = 255) => String(v == null ? '' : v).slice(0, n);
  const paths = () => { try { const p = JSON.parse(sessionStorage.getItem('tb_paths') || '[]'); return clip(p.join(' > ').slice(-255)); } catch (e) { return ''; } };

  // ---- where did the add come from? -------------------------------------------------------------------
  let lastPointer = null;
  document.addEventListener('pointerdown', (e) => { lastPointer = e.target; }, true);
  const ctx = (el) => {
    const page = document.documentElement.getAttribute('data-tb-page') || 'other';
    const near = (node, sel) => !!(node && node.closest && node.closest(sel));
    const inDrawer = near(el, 'cart-drawer-component, cart-drawer, #cart-drawer, .cart-drawer') || near(lastPointer, 'cart-drawer-component, cart-drawer, #cart-drawer, .cart-drawer');
    const sec = el && el.closest ? el.closest('.shopify-section') : null;
    let section = sec ? sec.id.replace(/^shopify-section-/, '').replace(/^template--\d+__/, '').replace(/^sections--\d+__/, '') : '';
    let kind = '';
    if (near(lastPointer, 'sticky-add-to-cart, .tb-sticky, [data-tb-sticky]')) kind = 'sticky';
    else if (near(el, 'tb-add-button, [data-tb-addons]') || near(lastPointer, 'tb-add-button')) kind = near(el, 'tb-complete-set, [data-tb-complete-set]') || near(lastPointer, 'tb-complete-set') ? 'complete-set' : 'addons';
    else if (near(el, 'quick-add-component, quick-add-dialog, product-card, .product-card, .tb-mini-card')) kind = 'quick-add';
    if (inDrawer) return clip(`cart-drawer|${kind || 'line'}`, 120);
    return clip(`${page}|${section || 'main'}${kind ? '-' + kind : ''}`, 120);
  };
  window.tbAddedFrom = ctx;

  // Hidden property on every product form, so Buy it now (which reads the form, not the cart) carries it too.
  const stamp = (form) => {
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    let input = form.querySelector('input[name="properties[_added_from]"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[_added_from]'; form.appendChild(input); }
    input.value = ctx(form);
  };
  const stampAll = () => document.querySelectorAll('form[action*="/cart/add"]').forEach(stamp);
  document.addEventListener('submit', (e) => stamp(e.target), true);
  document.addEventListener('pointerdown', (e) => { const f = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]'); if (f) stamp(f); }, true);
  if (document.readyState !== 'loading') stampAll(); else document.addEventListener('DOMContentLoaded', stampAll, { once: true });
  try { new MutationObserver(() => stampAll()).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}

  // ---- attributes on the cart ---------------------------------------------------------------------------
  let busy = false, again = false;
  const attach = async (force) => {
    if (busy) { again = true; return; }
    const last = read('tb_last_touch');
    const path = paths();
    if (!last && !force) return;
    busy = true;
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const have = (cart && cart.attributes) || {};
      const saved = (() => { try { return (JSON.parse(localStorage.getItem('tb_wishlist') || '[]') || []).join(',').slice(0, 255); } catch (e) { return ''; } })();
      if (have._touch_at === (last && last.at) && have._path === path && (have._saved || '') === saved) return;
      const first = read('tb_first_touch') || last;
      const attributes = { _path: path, _saved: saved };
      if (last) Object.assign(attributes, {
        _utm_source: clip(last.utm_source), _utm_medium: clip(last.utm_medium), _utm_campaign: clip(last.utm_campaign),
        _utm_content: clip(last.utm_content), _utm_term: clip(last.utm_term), _fbclid: clip(last.fbclid), _ad_params: clip(last.extra),
        _landing_page: clip(last.landing), _touch_at: clip(last.at),
        _ft_utm_campaign: clip(first.utm_campaign), _ft_landing: clip(first.landing), _ft_touch_at: clip(first.at),
      });
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes }) });
    } catch (e) {
      /* never interrupt shopping */
    } finally {
      busy = false;
      if (again) { again = false; setTimeout(() => attach(true), 200); }
    }
  };

  // ---- every add carries _added_from; every add/change re-attaches ----------------------------------------
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : input && input.url;
      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
        const from = ctx((lastPointer && lastPointer.closest && lastPointer.closest('form[action*="/cart/add"]')) || lastPointer);
        if (init.body instanceof FormData) {
          init.body.set('properties[_added_from]', from);  // at add time the tap origin is known (sticky bar, quick add)
        } else if (typeof init.body === 'string' && init.body[0] === '{') {
          const data = JSON.parse(init.body);
          const items = data.items || (data.id ? [data] : []);
          items.forEach((it) => { it.properties = it.properties || {}; if (!it.properties._added_from) it.properties._added_from = from; });
          init = { ...init, body: JSON.stringify(data) };
        }
      }
    } catch (e) {}
    const p = origFetch.call(this, input, init);
    try {
      const url = typeof input === 'string' ? input : input && input.url;
      if (url && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url) && !(init && init.body && String(init.body).includes('_touch_at'))) {
        p.then((r) => { if (r && r.ok) setTimeout(() => attach(true), 250); }, () => {});
      }
    } catch (e) {}
    return p;
  };

  if (document.readyState === 'complete') setTimeout(() => attach(false), 800);
  else window.addEventListener('load', () => setTimeout(() => attach(false), 800), { once: true });
  window.addEventListener('pageshow', (e) => { if (e.persisted) attach(false); });
  document.addEventListener('tb:wishlist', () => attach(true));
})();
